// extracted by mini-css-extract-plugin
module.exports = {"Input":"classes_Input__3I8V5","CheckboxButton":"classes_CheckboxButton__Ogsb4","buttonCheckBox":"classes_buttonCheckBox__2fPe-"};